import { Check } from "lucide-react";

// The only three visible steps of the fast flow (spec §1A): Încarcă → Verifică → Publică.
const STEPS = [
  ["Încarcă", "PDF sau fotografii"],
  ["Verifică", "Doar ce e marcat"],
  ["Publică", "Link și cod QR"],
] as const;

export function FlowSteps({ current }: { current: 0 | 1 | 2 }) {
  return (
    <ol className="steps flow" aria-label="Pașii publicării">
      {STEPS.map(([label, sub], i) => (
        <li
          key={label}
          aria-current={i === current ? "step" : undefined}
          className={i < current ? "done" : undefined}
        >
          <span className="n">
            {i < current ? <Check size={16} strokeWidth={2} aria-hidden="true" /> : i + 1}
          </span>
          {i < current && <span className="sr-only">Gata:</span>}
          <span style={{ fontSize: 15, fontWeight: 600 }}>{label}</span>
          <span className="caption muted" style={{ fontWeight: 400 }}>
            {sub}
          </span>
        </li>
      ))}
    </ol>
  );
}
